/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = 'boilerplate/Home/CHANGE_USERNAME';
export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD';
export const PASS_INV_VAL = 'boilderplate/FailedInvoice/PASS_INV_VAL'
export const RESET_FETCH_PASS = 'boilerplate/ewayBillGet/RESET_FETCH_FAILED'
export const ON_NOTIFY = 'boilerplate/ewayBillGet/ON_NOTIFY'
export const LOADER_STATUS = 'boilderplate/ewayBillGet/LOADER_STATUS'
export const TOTAL_RECORD = 'boilerplate/ewayBillGet/TOTAL_RECORD'
export const GET_ITEM = 'boilderplate/ewayBillGet/GET_ITEM'
export const TOTAL_ITEM_RECORDS = 'boilderplate/ewayBillGet/TOTAL_ITEM_RECORDS'
export const TXN_RECORD = 'boilerplate/ewayBillGet/TXN_RECORD'
export const DISABLE_EDIT = 'boilderplate/ewayBillGet/DISABLE_EDIT'
export const SET_PASS_PAGE = 'boilerplate/ewayBillGet/SET_PASS_PAGE'
export const EXTEND_DATA = 'boilerplate/ewayBillGet/EXTEND_DATA'
export const PASS_INV_VAL_MASTER = 'boilerplate/ewayBillGet/PASS_INV_VAL_MASTER'
export const SET_MODE_AND_GROUP = 'boilerplate/ewayBillGet/SET_MODE_AND_GROUP';
export const PROFILE_INFO = 'boilderplate/ewayBillGet/PROFILE_INFO';
export const SET_ITEMS_ERROR = 'boilerplate/ewayBillGet/SET_ITEMS_ERROR'